.heading {
  padding: 0.5rem 1rem;
  cursor: pointer;
}

.heading:hover {
  text-decoration: underline;
}

.content {
  margin: 0;
  padding: 0.75rem 1rem;
}
